import { BrokerNerdsBarkerCoreEnumsMarketplace } from '../api';
import { ReactNode } from 'react';
import tevo from './tevo.png';
import tnet from './tnet.jpeg';
import tm from './tm.png';
import sh from './sh.png';
import ticombo from './tc.webp';
import SeatGeekLogo from './sg.svg?react';

export function getMarketplaceLogo(marketplaceId?: BrokerNerdsBarkerCoreEnumsMarketplace | null): string | ReactNode {
  switch (marketplaceId) {
    case BrokerNerdsBarkerCoreEnumsMarketplace.SeatGeek:
      return <SeatGeekLogo />;
    case BrokerNerdsBarkerCoreEnumsMarketplace.StubHub:
      return sh;
    case BrokerNerdsBarkerCoreEnumsMarketplace.Ticketmaster:
      return tm;
    case BrokerNerdsBarkerCoreEnumsMarketplace.TicketNetwork:
      return tnet;
    case BrokerNerdsBarkerCoreEnumsMarketplace.TicketEvolution:
      return tevo;
    case BrokerNerdsBarkerCoreEnumsMarketplace.Ticombo:
      return ticombo;
    default:
      return null;
  }
}
